module.exports = __webpack_public_path__ + "static/media/Group 6.2cb4588b.png";